import { useDispatch, useSelector } from 'react-redux'
import { FlashList } from "@shopify/flash-list";
import * as XLSX from "xlsx"
import Preferance from '../constants/Preferances';

import { ActivityIndicator, SafeAreaView, View, StyleSheet, ScrollView, SectionList, Dimensions, Touchable, TouchableOpacity, Linking, Alert } from 'react-native';
import { Text, IconButton, Button, FAB, shadow, TextInput, Chip, Divider } from 'react-native-paper';

import * as React from 'react';
import DYear from '../components/DYear';
import { useTheme } from 'react-native-paper';
import NotificationRow from '../components/NotificationRow';
import ReactNativeModal from 'react-native-modal';
import { collection, doc, getFirestore, onSnapshot, query, setDoc, updateDoc, where } from 'firebase/firestore';
import Toast from 'react-native-root-toast';
import StudentPlainRow from '../components/StudentRowPlain';
import dayjs from 'dayjs';
import * as Share from 'expo-sharing';
import DImage from '../components/DImage';
import Global from '../constants/global';
import DIcon from '../components/DIcon';
import DModal from '../components/DModal';
import { listsTask } from '../task/listTasks';
import { SortBy } from 'expo-media-library';
import DChip from '../components/DChip';
import FABGroup from 'react-native-paper/lib/typescript/components/FAB/FABGroup';
const cy = Global.getYear()

let remover: [] = []
export default function StudentList({ navigation, route }) {
    // const bhudevList = useSelector(React.useMemo(Global.getUserList, []))
    const classes = useSelector((state) => state.list.Classes)
    const [selected, setSelected] = React.useState({ class: {}, available: [], viewClass: {}, reset: false })

    const [years, setYears] = React.useState({ old: cy - 1, new: cy })
    const [classList, setClassList] = React.useState({ old: [], new: [], available: [] })
    const [show, setShow] = React.useState(0)
    const dispatch = useDispatch()
    React.useEffect(() => {
        let s
        if (years.old < 2024) {
            const citiesRef = collection(getFirestore(), Global.CLASSES);

            let q = query(citiesRef, where("year", "==", years.old));

            s = onSnapshot(
                q, { includeMetadataChanges: true },
                (docc) => {
                    let tklist: [] = []
                    docc.docChanges().forEach((change) => {
                        if (change.type === "removed") {
                            dispatch(listsTask.actions.remove({ type: Global.CLASSES, data: change.doc.data() }))
                        } else {
                            const d = change.doc.data()
                            tklist.push({ data: d })
                        }
                    });

                    dispatch(listsTask.actions.updateActivity({ type: Global.CLASSES, data: tklist, isArray: true }))
                });
        }
        return () => {
            if (s) { s() }
        }
    }, [years])

    React.useEffect(() => {
        if (classes) {
            const s: [] = []
            const newL: [] = []
            classes.map(p => {
                if (years.old < 2024 ? p.year == years.old : p.final) {
                    s.push({ ...p })
                }
                if (p.final) {
                    newL.push({ ...p })
                }
            })
            const nnewP = s.sort((a, b) => a?.seq < b?.seq ? -1 : 0)
            const nnewL = newL.sort((a, b) => a?.seq < b?.seq ? -1 : 0)
            setClassList(p => ({ ...p, old: nnewP, new: nnewL }))

        }
    }, [classes, years])


    const st = { borderBottomWidth: 5, borderBottomColor: "lightgreen", fontWeight: "bold" }

    const themeColor = useTheme();
    const colors = themeColor.colors
    const showColor = themeColor.dark ? "black" : "#eaeaea"
    return (
        <View style={{ flex: 1 }}>
            <View style={{ backgroundColor: "white", alignSelf: "stretch" }}>
                <DImage width={170} uri="https://i.pinimg.com/564x/d2/57/67/d257676b21bfdda5ca88d3b7e4b54d87.jpg" />
            </View>
            <Year year={years.old} update={(yr) => {
                if (!(yr + 1 > cy)) {
                    setYears(p => ({ ...p, old: yr, new: yr + 1 }))
                }

            }} text="Old Year" />
            <Year year={years.new} disabled update={() => { }} text="New Year" />
            <View style={{ flexDirection: "row", marginTop: 20 }} >
                <TouchableOpacity style={{ padding: 10, alignItems: "center", flex: 1, backgroundColor: show == 0 ? showColor : undefined }} onPress={() => setShow(0)}>
                    <Text style={show == 0 ? st : {}} variant="labelLarge">Transfer</Text>
                </TouchableOpacity>
                <TouchableOpacity style={{ padding: 10, alignItems: "center", flex: 1, backgroundColor: show == 1 ? showColor : undefined }} onPress={() => setShow(1)}>
                    <Text style={show == 1 ? st : {}} variant="labelLarge">New Year ({Global.getYearString(years.new)}) Student List</Text>
                </TouchableOpacity>
            </View>

            {show == 0 && <View style={{ paddingTop: 20, flex: 1, backgroundColor: show == 0 ? showColor : undefined }} >
                <View style={{ flexDirection: "row", flexWrap: "wrap", justifyContent: "center", backgroundColor: "transparent" }}>
                    {
                        classList.old.map(e => {
                            return <Chip style={{ margin: 2 }} selected={e == selected.class} onPress={() => {
                                const avail = classList.new.filter(f => Global.getClassNo(f) >= Global.getClassNo(e))
                                setSelected(p => ({ ...p, class: e, available: avail, reset: true }))
                            }

                            }>{e.name + (e.div ? " " + e.div : "")}</Chip>
                        })
                    }
                </View>
                <ClassWiseStudent year={years.old} colors={colors} navigation={navigation} available={selected.available} selectedClass={selected.class} tranfering={true} reset={selected.reset} isDark={themeColor.dark} callback={() => {
                    setSelected(p => ({ ...p, reset: false }))
                }} />
            </View>}


            {show == 1 && <View style={{ paddingTop: 20, flex: 1, backgroundColor: show == 1 ? showColor : undefined }} >
                <View style={{ backgroundColor: "transparent", flexDirection: "row", flexWrap: "wrap", justifyContent: "center", alignItems: "center" }}>
                    {
                        classList.new.map(e => {
                            return <Chip style={{ margin: 2 }} selected={e.id == selected.viewClass.id} onPress={() => {

                                setSelected(p => ({ ...p, viewClass: e, reset: true }))
                            }

                            }>{e.name + (e.div ? " " + e.div : "")}</Chip>
                        })
                    }
                    <Button onPress={() => navigation.navigate("NewStudent")} icon={"plus"}> </Button>

                </View>
                <ClassWiseStudent year={years.new} colors={colors} navigation={navigation} available={selected.available} selectedClass={selected.viewClass} tranfering={false} reset={selected.reset} isDark={themeColor.dark} callback={() => {
                    setSelected(p => ({ ...p, reset: false }))
                }} />
            </View>}
        </View>
    );


}

const ClassWiseStudent = ({ year, colors, navigation, available, selectedClass, tranfering, reset, callback, isDark }) => {
    const [list, setList] = React.useState([])
    const clist = useSelector(s => s.list.Students)
    const [wait, setWait] = React.useState(false)
    const dispatch = useDispatch()
    React.useEffect(() => {
        if (selectedClass?.id) {
            const l = []
            if (clist) {
                clist.map(r => {
                    // //console.log(r["class" + year]?.classId, cl, r["class" + year]?.classId == cl)
                    if (r["class" + year]?.classId == selectedClass.id && r?.type == undefined) {
                        if (r?.flag && r?.flag == -10) {

                        } else {
                            l.push({ ...r })
                        }
                    }
                })
                const l1 = Global.sortStudent(l, year)
                setList(l1)
            } else {
                //console.log("inlist else")

                setList([])
            }
        }
    }, [clist])

    React.useEffect(() => {
        if (reset) {
            setList([])
            callback()
        }
    }, [reset])
    React.useEffect(() => {
        let s
        if (year && selectedClass?.id) {
            setWait(true)
            const db = getFirestore()
            const citiesRef = collection(db, Global.STUDENTS);
            let q = query(citiesRef, where("class" + year + ".classId", "==", selectedClass.id));

            s = onSnapshot(q, { includeMetadataChanges: true },
                (docc) => {
                    let tklist: [] = []
                    let del = []
                    docc.docChanges().forEach((change) => {
                        const d = change.doc.data()
                        if (change.type === "removed") {
                            dispatch(listsTask.actions.remove({ type: Global.STUDENTS, data: change.doc.data() }))
                        } else {
                            tklist.push({ data: d })
                        }
                    });

                    dispatch(listsTask.actions.updateActivity({ type: Global.STUDENTS, data: tklist, isArray: true }))

                    setWait(false)

                });
            remover.push(s)
        }
        return () => {
            // //console.log("cleanup", s)
            if (s) {
                try {
                    //console.log("cleanupdone")
                    s()
                } catch { }
            }
        }
    }, [year, selectedClass])

    return wait ? <ActivityIndicator animating /> : <FlashList
        data={list}
        key="id"
        estimatedItemSize={50}
        contentContainerStyle={{ backgroundColor: "transparent" }}
        keyboardShouldPersistTaps={'handled'}
        renderItem={({ item, index }) =>
            <Migration student={item} oldyear={year} colors={colors} navigation={navigation} selectedClass={selectedClass} available={available} tranfering={tranfering} isDark={isDark} />

        } />


}

const Migration = ({ student, oldyear, colors, navigation, selectedClass, available, tranfering, isDark }) => {
    const [mig, setMig] = React.useState({ newclass: "", status: -1, reason: "", newroll: 0, newgr: 0, saved: false, available: [] })
    const left = student["class" + oldyear]?.status == 1
    const move = student["class" + oldyear]?.status == 2
    const hasNewClass = student["class" + (oldyear + 1)]?.classId

    const done = left || move || hasNewClass
    // const currentClassNo = Global.getClassNo(selectedClass)
    // //console.log(availFail, availPass, available)

    return <View style={{ backgroundColor: done ? isDark ? "#084811ff" : "#4da6a6" : "transparent" }}>
        <StudentRow item={student} year={oldyear} colors={colors} navigation={navigation} />
        {done && <Text style={{ paddingLeft: 15 }}>{left ? "Left" : move ? "Moved" : "Transfered to " + student["class" + (oldyear + 1)]?.class + student["class" + (oldyear + 1)]?.div}</Text>}
        {tranfering && <View>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <DChip onPress={() => {
                        const currentClassNo = Global.getClassNo(selectedClass)
                        const availFail = available?.filter(f => f.classNo == currentClassNo)
                        // const availPass = available?.filter(f => f.classNo == (currentClassNo + 1))
                        let newGr = ""
                        try {
                            newGr = student["class" + oldyear].gr
                        } catch { }
                        if (availFail.length == 1) {
                            setMig(p => ({ ...p, status: 0, available: availFail, newclass: availFail[0], newgr: newGr }))
                        } else {
                            setMig(p => ({ ...p, status: 0, available: availFail, newgr: newGr }))
                        }
                    }} selected={mig.status == 0} >નાપાસ (Failed)</DChip>
                    <DChip onPress={() => {
                        const currentClassNo = Global.getClassNo(selectedClass)
                        // const availFail = available?.filter(f => f.classNo == currentClassNo)
                        let availPass = available?.filter(f => f.classNo == (currentClassNo + 1))
                        availPass.map((ac, i) => {
                            ac.faltuId = i + ""
                        })
                        let newGr = ""
                        try {
                            if (Global.getClassNo(selectedClass) !== 11) {
                                newGr = student["class" + oldyear].gr
                            }
                        } catch { }
                        if (availPass[0].classNo == 11) {
                            const arts = { ...availPass[0] }
                            const comm = { ...availPass[0] }
                            arts.stream = 2
                            arts.faltuId = "A"
                            comm.stream = 1
                            comm.faltuId = "C"
                            const a = []
                            a.push(comm)
                            a.push(arts)
                            availPass = a
                        }
                        if (availPass[0].classNo == 12) {
                            availPass[0].stream = student["class" + oldyear].stream
                        }

                        if (availPass.length == 1) {
                            setMig(p => ({ ...p, status: 5, available: availPass, newclass: availPass[0], newgr: newGr }))
                        } else {
                            setMig(p => ({ ...p, status: 5, available: availPass, newgr: newGr }))
                        }
                    }} selected={mig.status == 5} >ઉપલા વર્ગ માં ચઢાવ્યા(Pass)</DChip>
                    <DChip onPress={() => setMig(p => ({ ...p, status: 1 }))} selected={mig.status == 1} >Left study</DChip>
                    <DChip onPress={() => setMig(p => ({ ...p, status: 2 }))} selected={mig.status == 2} >Moved to other school </DChip>
                </View>
            </View>
            {/* {mig.status !== 0 && <TextInput label={"Reason"} value={mig.reason} onChangeText={(t) => { setMig(p => ({ ...p, reason: t })) }} />} */}
            {(mig.status == 0 || mig.status == 5) && <View>
                <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
                    {(mig.available).map(cl => {
                        return <DChip onPress={() => {
                            setMig(p => ({ ...p, newclass: cl }))
                        }} selected={mig.newclass?.faltuId == cl.faltuId} >{cl.name} {cl.div}  {cl.stream ? Global.STREAM[cl.stream] : ""}</DChip>
                    })}
                </View>
                <View style={{ flexDirection: "row" }}>
                    {mig.status == 5 && Global.getClassNo(mig.newclass) == 11 && <TextInput style={{ backgroundColor: "transparent", flex: 1 }} placeholder={'New GR No'} value={mig.newgr ? mig.newgr + "" : ""} onChangeText={(t) => {
                        const val = parseInt(t)
                        setMig(p => ({ ...p, newgr: isNaN(val) ? 0 : val }))

                    }} />}
                    {<TextInput placeholder='New Roll' style={{ marginLeft: 5, flex: 1, backgroundColor: "transparent", }} value={mig.roll ? mig.roll + "" : ""} onChangeText={(t) => {
                        const val = parseInt(t)
                        setMig(p => ({ ...p, roll: isNaN(val) ? 0 : val }))
                    }
                    } />}
                </View>
            </View>}
            <SaveButton mig={mig} student={student} oldyear={oldyear} />

        </View>}
        <Divider bold leftInset />
    </View >



}
const SaveButton = ({ mig, student, oldyear }) => {
    const [working, setWorking] = React.useState({ working: false, status: 0 })
    return <Button icon={working.status == 1 ? "check-bold" : working.status == -1 ? "alert" : undefined} mode="contained" loading={working.working} style={{ padding: 5, marginBottom: 15, alignSelf: "flex-end" }} onPress={() => {
        setWorking(p => ({ ...p, working: true }))
        const mi = { ...mig }
        let statusSelected = false
        let newClassSelected = false
        let grValid = false
        let rollGiven = false
        if (mi.status !== -1) {
            statusSelected = true
        }
        if (mi.newclass?.id) {
            newClassSelected = true
        }
        if (Global.getClassNo(mi.newclass) !== 11) {
            mi.newgr = student["class" + [oldyear]]?.gr
        }
        mi.newgr = mi.newgr + ""

        // //console.log("mi", mi)

        if (Global.getClassNo(mi.newclass) > 10) {
            mi.stream = mi.newclass.faltuId == "A" ? 2 : 1
        }


        if (mi.newgr?.trim()?.length > 1) {
            grValid = true
        }
        let rollPass = true
        if (newClassSelected) {
            if (mi.roll) {
                rollGiven = true
            } else {
                rollPass = false
            }
        }
        if (rollPass && grValid && newClassSelected && statusSelected) {
            save(mi, student, oldyear).then(res => {
                if (res) {
                    setWorking(p => ({ ...p, working: false, status: 1 }))

                } else {
                    setWorking(p => ({ ...p, working: false, status: -1 }))
                }
            })
        } else {
            if (!rollGiven) {
                alert("Roll no required")
                return
            }
            if (!grValid) {
                alert("New Gr No required")
                return
            }
            if (!newClassSelected) {
                alert("Please select class")
                return
            }
            if (!statusSelected) {
                alert("Please select student status")
                return
            }

        }
    }}> Save</Button >

}
async function save(mi, student, oldyear) {
    const erf = doc(getFirestore(), Global.STUDENTS, student.id)
    const toput = {}
    if (mi.status == 0 || mi.status == 5) {
        toput.class = mi.newclass.name
        toput.classId = mi.newclass.id
        toput.div = mi.newclass?.div ? mi.newclass?.div : ""
    }
    if (mi.newgr) {
        toput.gr = mi.newgr
    }
    if (mi?.roll) {
        toput.roll = mi?.roll ? mi?.roll : 0
    } else {
        toput.roll = 0
    }
    if (mi?.stream) {
        toput.stream = mi?.stream ? mi?.stream : (student?.stream ? student?.stream : 0)
    } else {
        toput.stream = (student?.stream ? student?.stream : 0)
    }
    // //console.log("mi", toput)
    const r = {
        [`class${oldyear + 1}`]: {
            gr: toput.gr,
            class: toput.class,
            classId: toput.classId,
            roll: toput.roll,
            div: toput.div,
            stream: toput.stream
        }
    }
    try {
        await updateDoc(erf, {
            [`class${oldyear + 1}`]: {
                gr: toput.gr,
                class: toput.class,
                classId: toput.classId,
                roll: toput.roll,
                div: toput.div,
                stream: toput.stream
            }
        }, { merge: true })
        return true
    } catch (e) {
        alert("Error saving data")
        return false
    }

}

const StudentRow = ({ item, year, navigation, colors }) => {
    const [options, setOptions] = React.useState(false)
    const [deletConf, setDeletConf] = React.useState(undefined)
    return <>
        {/* <TouchableOpacity onPress={() => setOptions(true)}> */}
        <StudentPlainRow info={item} withGr={true} withStream={true} currentYear={year} />
        {/* </TouchableOpacity> */}
        {/* < ReactNativeModal
            isVisible={options}
            onBackdropPress={() => setOptions(false)}
            onDismiss={() => setOptions(false)}
            style={{ margin: 0, position: "absolute", bottom: 0, width: Dimensions.get("window").width }} animationIn="slideInUp" >

            <View style={{ backgroundColor: colors.surface }}>
                <View style={{ justifyContent: "center" }}>
                    <Text variant="titleLarge" style={{ padding: 13, fontWeight: "bold", flex: 1 }}>{item?.name}...</Text>
                    {item?.mobile &&
                        <View style={{ flexDirection: "row", alignItems: "center", backgroundColor: "transparent" }}>
                            <TouchableOpacity style={{ flex: 1 }} onPress={() => { Linking.openURL('tel:' + item?.mobile); setOptions(false) }} >
                                <View style={{ flexDirection: "row", alignItems: "center", flex: 1 }}>
                                    <IconButton style={{ marginLeft: 10, marginRight: 10 }} icon="phone-outgoing" />
                                    <Text style={{ paddingLeft: 10, paddingRight: 10 }} >{"Mobile -"} ({item?.mobile})</Text>
                                </View>
                            </TouchableOpacity>
                            <IconButton style={{ marginLeft: 10, marginRight: 10 }} icon="whatsapp" onPress={() => { Share.shareAsync({ title: "નમસ્કાર", "message": "આપનો દિવસ શુભ રહે 🙂" }) }} />
                        </View>
                    }
                    <TouchableOpacity onPress={() => { setOptions(false); navigation.navigate("NewStudent", { data: focus }) }}>
                        <View style={{ flexDirection: "row", alignItems: "center", backgroundColor: "transparent" }}>
                            <IconButton style={{ marginLeft: 10, marginRight: 10 }} icon="lead-pencil" />
                            <Text style={{ paddingLeft: 10, paddingRight: 10 }} >Edit</Text>
                        </View>
                    </TouchableOpacity>
                    <TouchableOpacity onPress={() => {
                        setOptions(false);
                        left(item)
                    }}>
                        <View style={{ flexDirection: "row", alignItems: "center", backgroundColor: "transparent" }}>
                            <IconButton style={{ marginLeft: 10, marginRight: 10 }} icon="account-off" />
                            <Text style={{ paddingLeft: 10, paddingRight: 10 }} >Mark as {item?.left == true ? "Not Left" : "Left"}</Text>
                        </View>
                    </TouchableOpacity>

                    <TouchableOpacity onPress={() => { setDeletConf(item.id); setOptions(false) }}>
                        <View style={{ flexDirection: "row", alignItems: "center", backgroundColor: "transparent" }}>
                            <IconButton style={{ marginLeft: 10, marginRight: 10 }} icon="delete" />
                            <Text style={{ paddingLeft: 10, paddingRight: 10 }} >Delete</Text>
                        </View>
                    </TouchableOpacity>
                </View>
                <IconButton icon={"window-close"} onPress={() => setOptions(false)} style={{ position: "absolute", top: 0, right: 0 }} />
            </View>
        </ReactNativeModal>
        < ReactNativeModal
            isVisible={deletConf !== undefined}
            onBackdropPress={() => setDeletConf(undefined)}
            onDismiss={() => setDeletConf(undefined)}
            style={{ margin: 0, position: "absolute", bottom: 0, width: Dimensions.get("window").width }} animationIn="slideInUp" >

            <View style={{ backgroundColor: colors.surface }}>
                <View style={{ justifyContent: "center" }}>
                    <Text variant="titleLarge" style={{ padding: 13, fontWeight: "bold", flex: 1 }}>{deletConf?.name}...</Text>
                    <Text style={{ padding: 13, fontWeight: "bold", flex: 1 }}>Are you sure ? All Student's data including his result data will be removed </Text>
                    <View style={{ flexDirection: "row" }}>
                        <Button onPress={() => setDeletConf(undefined)} style={{ flex: 1 }}>Cancel</Button>
                        <Button onPress={() => { delStudent(item.id) }} mode="contained" style={{ flex: 1 }}>Delete</Button>
                    </View>

                </View>
                <IconButton icon={"window-close"} onPress={() => setDeletConf(undefined)} style={{ position: "absolute", top: 0, right: 0 }} />
            </View>
        </ReactNativeModal> */}

    </>


}

const Year = ({ year, disabled = false, update, text }) => {
    const [show, setShow] = React.useState(false)

    return <View><TouchableOpacity onPress={() => {
        if (!disabled) {
            setShow(true)
        }
    }}>
        <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Text variant="titleLarge">{text}: {Global.getYearString(year)}</Text>
            {!disabled && <DIcon name="cog" color='black' />}
        </View>
    </TouchableOpacity>
        <DYear show={show} text={text} year={year} close={() => {
            setShow(false)
        }} change={(yr) => {
            update(yr)
            setShow(false)
        }} />

    </View>

}